// Originalfotos der alten Gewürz-Seiten (www.balivwtour.com), große Auflösung.
export const spicePhotos: Record<string, string[]> = {
  kardamom: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/cadamon01_large.jpg",
  ],
  wachsnuss: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/candlenut01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/kemiri01_large.jpg",
  ],
  chilli: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/chilli01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/chilli01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/chilli02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/chilli03_large.jpg",
  ],
  chillipfeffer: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/chillipepper01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/chillypepper01_large.jpg",
  ],
  zimt: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/cinnamon_stick02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/cinnamomum01_large.jpg",
  ],
  gewuerznelken: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/clove01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/clove_plantation01_large.jpg",
  ],
  kreuzkuemmel: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/crosscumin01_large.jpg",
  ],
  ingwer: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/ginger01_large.jpg",
    "https://www.balivwtour.com/images_large/spices_of_bali_large/ginger02_large.jpg",
  ],
  gelbwurz: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/kunyit02_large.jpg",
    "https://www.balivwtour.com/images_large/spices_of_bali_large/kunyit03_large.jpg",
  ],
  zitronengras: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/lemongrass01_large.jpg",
    "https://www.balivwtour.com/images_large/spices_of_bali_large/lemongrass02_large.jpg",
  ],
  falscherSafran: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/no_saffran01_large.jpg",
  ],
  muskatnuss: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/nutmeg_fruit01_large.jpg",
    "https://www.balivwtour.com/images_large/spices_of_bali_large/nutmeg_fruit02_large.jpg",
  ],
  pfeffer: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/pepper01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/pepperplant01_large.jpg",
  ],
  sternanis: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/star_anis02_large.jpg",
    "https://www.balivwtour.com/images_large/spices_of_bali_large/star_anis01_large.jpg",
  ],
  tamarind: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/tamarind01_large.jpg",
    "https://www.balivwtour.com/images_large/spices_of_bali_large/tamarind02_large.jpg",
  ],
  vanille: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/vanilla02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/vanillaflower01_large.jpg",
    "https://www.balivwtour.com/images_large/spices_of_bali_large/vanillie01_large.jpg",
  ],
  betelpalme: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/betelnut01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/betelpalm01_large.jpg",
  ],
  betelpfeffer: [
    "https://www.balivwtour.com/images_large/spices_of_bali_large/betelnut02_large.jpg",
    "https://www.balivwtour.com/images_large/spices_of_bali_large/betelnut03_large.jpg",
  ],
  kaffee: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/coffee_fruit02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/coffee_blossom02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/coffee_fruit04_large.jpg",
    "https://www.balivwtour.com/images_large/spices_of_bali_large/coffee01_large.jpg",
  ],
  kakao: [
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/cacao_beans01_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/cacao_fruit02_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/cacao_fruit03_large.jpg",
    "https://www.balivwtour.com/images_large/fruits_and_plants_of_bali_large/cacao_fruit04_large.jpg",
  ],
};